"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue, PropSync } from "vue-property-decorator";
import UiDialog from "../../../components/dialog/UiDialog.vue";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import UiSubmit from "@/components/form/UiSubmit.vue";
import API from "@ym-framework/api-utils";
import { AccountPinModel } from "@/models/Auth.model";
import { DeviceFormatter } from "@/service/DeviceInfo/deviceFormatter";
import i18n from "@/lang";
import { AccountAuth } from "@/framework/accountauth";
class FormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.form_code = "";
    this.form_remember = false;
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("authpinlogin.verification_code_cannot_be_empty"),
      trigger: "blur"
    }
  ])
], FormController.prototype, "form_code", 2);
let AuthPinLogin = class extends Vue {
  constructor() {
    super(...arguments);
    this.Pin_data = new AccountPinModel();
    this.span_text = this.$t("authpinlogin.failure_after_minutes");
    this.submit = false;
    this.device_item = null;
    this.loginType = "form";
    this.formcontroller = new FormController();
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.checkVisitorId();
    });
  }
  checkVisitorId() {
    return __async(this, null, function* () {
      try {
      } catch (error) {
        console.log(error);
      }
    });
  }
  open(data, type) {
    return __async(this, null, function* () {
      this.submit = false;
      this.Pin_data = data;
      this.loginType = type;
      this._pin_dialog.show();
      yield this.getDevice();
    });
  }
  getDevice() {
    return __async(this, null, function* () {
      let device = yield DeviceFormatter.getInfo();
      console.log(device);
      this.device_item = device;
    });
  }
  sendLog(session) {
    return __async(this, null, function* () {
      try {
        let device = yield DeviceFormatter.getInfo();
        let version = yield API.get(`api://base.local/update/version`);
        let _version = version.data.version;
        let time = yield API.get(`api://base.local/device_time`);
        let _time = time.data.time;
        yield API.post(`api://base.auth/api/v3/client/logs`, {
          logs: [
            {
              name: "client.login",
              message: "login.success",
              datas: {
                time: {
                  time: new Date().getTime(),
                  date: new Date()
                },
                session,
                version: _version,
                patch: _version,
                computer: {
                  graphics: device.device_info.detail.graphics,
                  os_arch: device.device_info.os_arch,
                  cpu: device.device_info.detail.cpu,
                  os: device.device_info.detail.osInfo,
                  memory: device.device_info.detail.mem,
                  network: device.device_info.detail.networkInterfaces,
                  time: __spreadValues({
                    date: new Date()
                  }, _time)
                }
              }
            }
          ]
        });
      } catch (error) {
        console.dir(error);
      }
    });
  }
  submitPin() {
    return __async(this, null, function* () {
      try {
        let _visitor_id = this.$matomo.getVisitorId();
        this.submit = true;
        yield API.post(
          `api://base/api/v7/accounts/device/authorization_account`,
          {
            phone: this._phone_authid,
            // phone_prefix: this._phone_authidprefix,
            verify_code: this.formcontroller.form_code,
            no_need_verify: this.formcontroller.form_remember,
            org_id: this.Pin_data.org_guid
          },
          {
            headers: {
              "X-AUTH-TOKEN": this.Pin_data.token
            }
          }
        );
        if (this.loginType === "form") {
          let response = yield API.post(`api://base/api/v7_1/auth`, {
            auth_id: this._phone_authid,
            password: this._phone_password,
            device_info: this.device_item.device_info,
            device_mini: this.device_item.device_mini,
            device_name: this.device_item.device_name,
            pin_verify_status: true,
            visitor_id: _visitor_id,
            save_account: this._phone_remember
          });
          yield API.put(`api://base.local/storages/preference/token`, {
            token: response.data.account_session.token
          });
          let _session = yield API.get(`api://base.auth/api/v9/account/session`);
          const session = _session.data;
          yield API.put(`api://base.local/storages/session/session`, { session });
          console.log(this.$matomo);
          this.$matomo.setUserId(_session.data.id);
          yield AccountAuth.authAfter(_session.data);
          yield this.sendLog(_session.data);
          let _href = location.href.split("login")[0] + "index.html#/dashboard";
          window.open(_href, "_blank");
          console.log("kjvs://close");
          window.close();
        }
        if (this.loginType === "wechat") {
          let response = yield API.post(`api://base/api/v7_1/account/auth_by_token`, {
            // let response = await API.post(`api://base/api/v7/account/auth_by_token`,{
            device_info: this.device_item.device_info,
            device_mini: this.device_item.device_mini,
            device_name: this.device_item.device_name,
            pin_verify_status: true,
            visitor_id: _visitor_id,
            token: this.Pin_data.token
          });
          yield API.put(`api://base.local/storages/preference/token`, {
            token: response.data.account_session.token
          });
          let _session = yield API.get(`api://base.auth/api/v9/account/session`);
          const session = _session.data;
          yield API.put(`api://base.local/storages/session/session`, { session });
          console.log(this.$matomo);
          this.$matomo.setUserId(_session.data.id);
          yield AccountAuth.authAfter(_session.data);
          yield this.sendLog(_session.data);
          let _href = location.href.split("login")[0] + "index.html#/dashboard";
          window.open(_href, "_blank");
          console.log("kjvs://close");
          window.close();
        }
        if (this.loginType === "team") {
          let response = yield API.post(`api://base/api/v7_1/account/auth_by_token/org/${this.Pin_data.org_guid}`, {
            device_info: this.device_item.device_info,
            device_mini: this.device_item.device_mini,
            device_name: this.device_item.device_name,
            pin_verify_status: true,
            visitor_id: _visitor_id,
            token: this.Pin_data.token
          });
          yield API.put(`api://base.local/storages/preference/token`, {
            token: response.data.account_session.token
          });
          let _session = yield API.get(`api://base.auth/api/v9/account/session`);
          const session = _session.data;
          yield API.put(`api://base.local/storages/session/session`, { session });
          console.log(this.$matomo);
          this.$matomo.setUserId(_session.data.id);
          yield AccountAuth.authAfter(_session.data);
          yield this.sendLog(_session.data);
          location.reload();
        }
      } catch (error) {
        this.submit = false;
        console.log(error);
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("pin-dialog")
], AuthPinLogin.prototype, "_pin_dialog", 2);
__decorateClass([
  PropSync("phoneAuthid", {
    default: function() {
      return "";
    }
  })
], AuthPinLogin.prototype, "_phone_authid", 2);
__decorateClass([
  PropSync("phonePassword", {
    default: function() {
      return "";
    }
  })
], AuthPinLogin.prototype, "_phone_password", 2);
__decorateClass([
  PropSync("phoneRemember", {
    default: function() {
      return false;
    }
  })
], AuthPinLogin.prototype, "_phone_remember", 2);
AuthPinLogin = __decorateClass([
  Component({
    components: { UiSubmit, UiForm, UiDialog }
  })
], AuthPinLogin);
export {
  AuthPinLogin as default
};
